<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 8C5.58579 8 5.25 8.33579 5.25 8.75C5.25 9.16421 5.58579 9.5 6 9.5C6.41421 9.5 6.75 9.16421 6.75 8.75C6.75 8.33579 6.41421 8 6 8ZM6 2.5C5.75454 2.5 5.55039 2.67688 5.50806 2.91012L5.5 3V6.5L5.50806 6.58988C5.55039 6.82312 5.75454 7 6 7C6.24546 7 6.44961 6.82312 6.49194 6.58988L6.5 6.5V3L6.49194 2.91012C6.44961 2.67688 6.24546 2.5 6 2.5Z" />
  </svg>
</template>
